import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-page-header',
  imports: [RouterLink],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css'
})
export class PageHeaderComponent {

  pageTitle = '';
  breadcrumb = '';
  homeUrl = '';

  constructor(private router: Router, private route: ActivatedRoute,
    private authSerive: AuthService
  ){
    this.router.events.pipe(filter(event=> event instanceof NavigationEnd))
    .subscribe(()=>{
      const child = this.getChild(this.route)
      this.pageTitle = child.snapshot.data['title']
      this.breadcrumb = child.snapshot.data['breadcrumb']
    })
  }
  getChild(route: ActivatedRoute): ActivatedRoute {
    while(route.firstChild){
      route = route.firstChild;
    }
    return route
  }

  ngOnInit(): void {
    this.userDetails();
  }
  userDetails(){
    const userDetails = this.authSerive.getUserDetails();
    console.log(userDetails);
    const role = userDetails.role;
    switch(role){
      case 'HOD':
        this.homeUrl = '/dashboard';
        break;
      case 'FACULTY':
        this.homeUrl = '/faculty/dashboard';
        break;
      case 'DEPT':
        this.homeUrl = '/dashboard';
        break;
      case 'CA':
        this.homeUrl = '/computerassistant/dashboard';
        break;
      case 'SUPER':
        this.homeUrl = '/principal/dashboard'
        break;
      case 'COE':
        this.homeUrl = '/coe/dashboard'
        break;
      default:
        this.homeUrl = '/dashboard';
        break;
    }
  }
}
